import * as z from "zod";
import { ResourceLibraryItemCreationPayload } from "./resourceLibrary";
import { ValidationMessageKey } from "./validationMessages";

export const ProductType = z.union([
  z.literal("Physical device only"),
  z.literal("Software only"),
  z.literal("Combination of physical device and software"),
]);

export type ProductType = z.infer<typeof ProductType>;

export const Product = z.object({
  id: z.string(),
  name: z
    .string()
    .nonempty(ValidationMessageKey.nonEmpty)
    .max(100, ValidationMessageKey.maxLength100),
  type: ProductType.optional(),
  tags: z.number().array().optional(),
  productQri: z.string().max(255).nullish(),
});
export type Product = z.infer<typeof Product>;

export const ProductWithoutId = Product.omit({ id: true });
export type ProductWithoutId = z.infer<typeof ProductWithoutId>;

/**
 * `productQri` is re-declared rather than `.required()`-ed: the base field is
 * `.nullish()`, and `.required()` only strips the outer optional, so `null`
 * and `""` would both still satisfy it.
 */
export const ProductFormFields = z.discriminatedUnion("productSource", [
  ProductWithoutId.omit({ productQri: true }).extend({
    productSource: z.literal("none"), // No linked product: either the Feature Flag is off, or the user cleared the picker.
  }),
  ProductWithoutId.omit({ productQri: true }).extend({
    productSource: z.literal("existing"),
    productQri: z.string().nonempty().max(255),
  }),
  ProductWithoutId.omit({ productQri: true }).extend({
    productSource: z.literal("new"),
    resourceLibraryProductToCreate: ResourceLibraryItemCreationPayload,
  }),
]);
export type ProductFormFields = z.infer<typeof ProductFormFields>;
